import { STORE_ITEM_ANALYTICS_LOCATION } from '@wwe-portal/web/utils/constants/keys';
import { safeSetLocalStorage } from '@wwe-portal/web/libs/storage/safe-local-storage';
import { getStorageItem } from '../bridge/local-storage';
import pageNames from './path-data.json';

export const getPageInfo = (path: string) => {
  const page = pageNames.find((page) => {
    const paths = typeof page.path === 'string' ? [page.path] : page.path;
    if (page.exact) {
      return paths.includes(path);
    }
    return paths.some((p) => path.startsWith(p));
  });
  return page
    ? { id: page.id, pageName: page.pageName }
    : { id: null, pageName: null };
};

export const getPreviousPageInfo = () => {
  return getPageInfo(
    getStorageItem(STORE_ITEM_ANALYTICS_LOCATION)?.previousPath ?? ''
  );
};

export const setPreviousPage = (pathname: string) => {
  const historyLocation = getStorageItem(STORE_ITEM_ANALYTICS_LOCATION) ?? {
    previousPath: '',
    currentPath: '',
  };
  historyLocation.previousPath = historyLocation.currentPath ?? '';
  historyLocation.currentPath = pathname;
  safeSetLocalStorage(STORE_ITEM_ANALYTICS_LOCATION, () =>
    JSON.stringify(historyLocation)
  );
};
